import { createSlice } from '@reduxjs/toolkit';
import {format} from 'date-fns';
import { CHECK_CUSTOMER_NUMBER, DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT, DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT_OVERVIEW, DASHBOARD_TREAMENTOUTCOME_ASSESSMENT, DASHBOARD_WOUNDASSESSMENT, DASHBOARD_WOUNDASSESSMENT_OVERVIEW, ERROR_STATUS, QUALITY_ASSURANCE_REPORT, REPORT_DASHBOARD, SUCCESS_STATUS, TREATMENT_REPORT } from '../constants';
import { Service } from '../service';
import { constructEndpoint, daysAgo } from '../utils/commonHelper';
import { setError, setLoading } from './appSlice';
import { LOADING_KEYS } from '../constants/loadingKeys';
const { request } = Service;

export const woundReportSlice = createSlice({
    name: 'woundreport',
    initialState: {
      overViewData:{},
      woundCountData:{},
      woundAssessmentData:{},
      treatmentOverViewData:{},
      treatmentWorklistData:{},
      surveyListLoader: false,
      surveryListOptions: {}, // Survey list options
      surveyResults: {}, // Survey result
      surveyResultsCsv: {}, // For CSV download
      surveyResultsLoader: false,
      customerAvailable: null, // Check wheater customer exists or not
      qualityAssuranceOverViewData:{},
      qualityAssuranceCountData:{},
      qualityAssuranceAssessmentData:{},
      platformOverview: {}, // State for stroing platform overview
      platformResults: {}, // Platform results
      platformResultsCsv: {}, // For CSV downlaod
      woundReportCsv:{},
      treatmentReportCsv:{},
      qualityReportCsv:{},
      woundReportPayload:{},
      treatmentReportPayload:{},
      qualityReportPayload:{},
      isSurveyDownloadReady:'',
      qaOverViewPagesData:{},
      woundReportOverviewDownloadCsvfile: {},
      reportSyncStatus: {},
    },
    reducers: {
      setOverViewData:(state,action)=>{
        state.overViewData=action.payload
      },
      setWoundCountData:(state,action)=>{
        state.woundCountData=action.payload
      },
      setWoundAssessmentData:(state,action)=>{
        state.woundAssessmentData=action.payload
      },
      setTreatmentOverViewData:(state,action)=>{
        state.treatmentOverViewData=action.payload
      },
      setTreatmentWorklistData:(state,action)=>{
        state.treatmentWorklistData=action.payload
      },
      setSurveyListLoader:(state, action) => { // Survey list options
        state.surveyListLoader = action.payload
      }, 
      setSurveryListOptions:(state, action) => { // Survey list options
        state.surveryListOptions = action.payload
      }, 
      setSurveyResults:(state, action) => { // Survey result
        state.surveyResults = action.payload
      },
      setSurveyResultsLoader:(state, action) => {
        state.surveyResultsLoader = action.payload
      },
      setSurveyResultsCsv:(state, action) => { // Survey result
        state.surveyResultsCsv = action.payload
      },
      setCustomerAvailable:(state, action) => { // Check wheater customer exists or not
        state.customerAvailable = action.payload
      },
      setQualityAssuranceOverViewData:(state,action)=>{
        state.qualityAssuranceOverViewData=action.payload
      },
      setQualityAssuranceCountData:(state,action)=>{
        state.qualityAssuranceCountData=action.payload
      },
      setQualityAssuranceAssessmentData:(state,action)=>{
        state.qualityAssuranceAssessmentData=action.payload
      },
      setPlatformOverview: (state, action) => { // Saving platform overview data
        state.platformOverview = action.payload
      },
      setPlatformResults: (state, action) => { // Saving platform results grid
        state.platformResults = action.payload
      },
      setPlatformResultsCsv: (state, action) => { // Saving platform results CSV data
        state.platformResultsCsv = action.payload
      },
      setWoundReportCsv:(state,action)=>{
        state.woundReportCsv=action.payload
      },
      setTreatmentReportCsv:(state,action)=>{
        state.treatmentReportCsv=action.payload
      },
      setQualityReportCsv:(state,action)=>{
        state.qualityReportCsv=action.payload
      },
      setWoundReportPayload:(state,action)=>{
        state.woundReportPayload=action.payload
      },
      setTreatmentReportPayload:(state,action)=>{
        state.treatmentReportPayload=action.payload
      },
      setQualityReportPayload:(state,action)=>{
        state.qualityReportPayload=action.payload
      },
      setIsSuveyDownloadReady: (state, action) => {
        state.isSurveyDownloadReady = action.payload
      },
      setqaOverViewPagesData: (state, action) => {
        state.qaOverViewPagesData = action.payload
      },
      setWoundReportOverviewDownloadCsvfile: (state, action) => {
        state.woundReportOverviewDownloadCsvfile = action.payload
      },
      setReportSyncStatus: (state, action) => {
        state.reportSyncStatus = action.payload
      }
    }
})

export const {
    setOverViewData,
    setWoundCountData,
    setWoundAssessmentData,
    setTreatmentOverViewData,
    setTreatmentWorklistData,
    setSurveyListLoader,
    setSurveryListOptions,
    setSurveyResults,
    setSurveyResultsLoader,
    setCustomerAvailable,
    setQualityAssuranceOverViewData,
    setQualityAssuranceCountData,
    setQualityAssuranceAssessmentData,
    setSurveyResultsCsv,
    setPlatformOverview,
    setPlatformResults,
    setPlatformResultsCsv,
    setWoundReportCsv,
    setTreatmentReportCsv,
    setQualityReportCsv,
    setWoundReportPayload,
    setTreatmentReportPayload,
    setQualityReportPayload,
    setIsSuveyDownloadReady,
    setqaOverViewPagesData,
    setWoundReportOverviewDownloadCsvfile,
    setReportSyncStatus,
} = woundReportSlice.actions;
 
export const getWoundDashBoardOverview = (payload) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setOverViewData({}));
    const data = await request(
      `${REPORT_DASHBOARD}/overview`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      "REPORT"
    );
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
      dispatch(setOverViewData(data.data));
    }
    if (data && data.status === ERROR_STATUS) {
    }
  } catch (error) {
    const obj = { ...error };
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage));
  } finally {
    dispatch(setLoading(false));
  }
};

export const getWoundDashBoardWoundcount = (payload) => async dispatch =>{
  try {
    dispatch(setLoading(true));
    dispatch(setWoundCountData({}));
    const data = await request(
      `${REPORT_DASHBOARD}/woundcount`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      "REPORT"
    );
    if (data && (data.status?.toLowerCase() === SUCCESS_STATUS)) {
      dispatch(setWoundCountData(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}   

// Wound Assessment
export const getWoundDashBoardAssessment = (payload) => async dispatch => {
  const url = payload.url;
  const queryParam = payload.queryParam && payload?.queryParam
  const method = payload.method
  const payloadData= payload.payload
  dispatch(setWoundAssessmentData({}))
  try {
    dispatch(setLoading(true));
    const data = await request(constructEndpoint(url, queryParam), {
      method: method,
      body: JSON.stringify(payloadData),
      loadingKey: LOADING_KEYS.WOUND_DASHBOARD_ASSESSMENT,
    }, "REPORT");
    
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
      data.data.woundAssessment.map((value)=>{
        value['admissionDate'] = (value.admissionDate) ? format(new Date(value.admissionDate.replace('Z', '')), 'MMMM dd, yyyy') : '';
        const _photoDate1 = value.photoTakenon ? new Date(value.photoTakenon) : null;
        const _today1 = new Date();
        const _days1 = _photoDate1
          ? Math.floor((new Date(_today1.getFullYear(), _today1.getMonth(), _today1.getDate()) - new Date(_photoDate1.getFullYear(), _photoDate1.getMonth(), _photoDate1.getDate())) / (1000 * 60 * 60 * 24))
          : null;
        value['lastAssessedDate'] = _days1 === null ? "No photo" : _days1 === 0 ? 'Today' : _days1 === 1 ? '1 Day ago' : `${_days1} Days ago`;
        value['lastAccessed'] = (value.lastAccessed) ? format(new Date(value.lastAccessed.replace('Z', '')), 'MMMM dd, yyyy') : '';
        value['signedDate'] = (value.signedDate) ? format(new Date(value.signedDate.replace('Z', '')), 'MMMM dd, yyyy') : null;
        value['lockedDate'] = (value.lockedDate) ? format(new Date(value.lockedDate.replace('Z', '')), 'MMMM dd, yyyy') : null;
        value['dischargeDate'] = (value.dischargeDate) ? format(new Date(value.dischargeDate), 'MMMM dd, yyyy') : '';
        value['dob'] = (value.dob) ? format(new Date(value.dob), 'MMMM dd, yyyy') : '';
        value['photoTakenon'] = _photoDate1 ? format(_photoDate1, 'MMMM dd, yyyy') : '';
        value['woundStatus'] = value?.woundStatus ? value.woundStatus.charAt(0).toUpperCase() + value?.woundStatus.slice(1) : ""
      })
      dispatch(setWoundAssessmentData(data.data))
      if(payload.url=== `${DASHBOARD_WOUNDASSESSMENT_OVERVIEW}/activewoundsnotresolved`){     
        dispatch(postWoundReportOverviewDownloadCsvReports(url, payloadData))
      }
      if(payload.url=== `${REPORT_DASHBOARD}/active-patient-list`){     
        dispatch(postWoundReportOverviewDownloadCsvReports(url, payloadData))
      }
    }
  }
  catch (error) {
    const obj = { ...error }
    dispatch(setError(obj.errorMessage))
  } 
  finally {
    dispatch(setLoading(false));
  }
}

export const postWoundReportOverviewDownloadCsvReports = (url, payloadData) => async (
  dispatch
) => {    
  let urlPath;
  if(url=== `${DASHBOARD_WOUNDASSESSMENT_OVERVIEW}/activewoundsnotresolved`){
    urlPath = `${DASHBOARD_WOUNDASSESSMENT_OVERVIEW}/activewoundsnotresolved/csv`
  }
  if(url===`${REPORT_DASHBOARD}/active-patient-list`){
    urlPath = `${REPORT_DASHBOARD}/active-patient-list/csv`
  }
  dispatch(setWoundReportOverviewDownloadCsvfile({}))
  try {
    dispatch(setLoading(true));  
    const resp = await request(urlPath, {
      method: "POST",
      body: JSON.stringify(payloadData),
    }, "REPORT");

    if (resp && resp.status?.toLowerCase() === SUCCESS_STATUS) {
      const finalDat = resp.data;
      // finalDat.Postdata = payloadData;       
    if (finalDat && Array.isArray(finalDat?.reports)) {
      finalDat?.reports.map((value) => {      
        value['admissionDate'] = (value.admissionDate) ? format(new Date(value.admissionDate), "MM/dd/yyyy") : '';
        const _photoDate2 = value.photoTakenon ? new Date(value.photoTakenon) : null;
        const _today2 = new Date();
        const _days2 = _photoDate2
          ? Math.floor((new Date(_today2.getFullYear(), _today2.getMonth(), _today2.getDate()) - new Date(_photoDate2.getFullYear(), _photoDate2.getMonth(), _photoDate2.getDate())) / (1000 * 60 * 60 * 24))
          : null;
        value['lastAssessedDate'] = _days2 === null ? "No photo" : _days2 === 0 ? 'Today' : _days2 === 1 ? '1 Day ago' : `${_days2} Days ago`;
        value['lastAccessed'] = (value.lastAccessed) ? format(new Date(value.lastAccessed), "MM/dd/yyyy") : '';
        value['signedDate'] = (value.signedDate) ? format(new Date(value.signedDate), "MM/dd/yyyy") : null;
        value['lockedDate'] = (value.lockedDate) ? format(new Date(value.lockedDate), "MM/dd/yyyy") : null;
        value['dischargeDate'] = (value.dischargeDate) ? format(new Date(value.dischargeDate), "MM/dd/yyyy") : '';
        value['photoTakenon'] = _photoDate2 ? format(_photoDate2, "MM/dd/yyyy") : '';
        value['dob'] = (value.dob) ? format(new Date(value.dob), 'MMMM dd, yyyy') : '';
        value['woundStatus'] = value?.woundStatus ? value.woundStatus.charAt(0).toUpperCase() + value?.woundStatus.slice(1) : ""
      });
    }
      dispatch(setWoundReportOverviewDownloadCsvfile(finalDat));

    } else {
      if (resp.message) {
        dispatch(setError(resp.message));
      }
    }
  } catch (error) {
    const obj = { ...error };
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage));
  } finally {
    dispatch(setLoading(false));
  }
};

//Treatment Outcome overview
export const getTreatmentOutcomeOverViewData = (payload) => async dispatch =>{
  try {
    dispatch(setLoading(true));
    const data = await request(`${TREATMENT_REPORT}/overview`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }, "REPORT");
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
      dispatch(setTreatmentOverViewData(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}


// Treatment Worklist 
export const getTreatmentWorklist  = (payload) => async dispatch => {
  const url = payload.url;
  const queryParam = payload.queryParam && payload?.queryParam
  const method = payload.method
  const payloadData= payload.payload
  try {
    const data = await request(constructEndpoint(url, queryParam), {
      method: method,
      body: JSON.stringify({...payloadData, isDischargedPatient: false, woundType: payload?.woundType || []}),
      loadingKey: LOADING_KEYS.TREATMENT_REPORT,
    }, "REPORT");
    
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
      dispatch(setTreatmentWorklistData(data.data))
    }
  }
  catch (error) {
    const obj = { ...error }
    dispatch(setError(obj.errorMessage))
  }
}

// Get survey list

export const getSurveyListOptions = (payload) => async dispatch =>{
  try {
    dispatch(setLoading(true));
    dispatch(setSurveyListLoader(true));
    const data = await request(`/reports/surveylistoptions`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    if (data && data.status === SUCCESS_STATUS) {
      dispatch(setSurveryListOptions(data.data));
    }
  }
  catch (error) {    
    dispatch(setSurveryListOptions({}));
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
    dispatch(setSurveyListLoader(false));
  }
}

// Getting survey results

export const getSurveyResults = (payload) => async dispatch =>{
  try {
    dispatch(setLoading(true));
    dispatch(setSurveyResultsLoader(true))
    const data = await request(`/reports/survey?limit=50`, {
      method: 'POST',
      body: JSON.stringify(payload),
      loadingKey: LOADING_KEYS.SURVERY_RESULTS,
    });
    if (data && data.status === SUCCESS_STATUS) {
      data.data.survey.map((value)=>{
        value['submittedOn'] = (value.submittedOn) ? format(new Date(value.submittedOn), 'MMM dd, yyyy hh:mm aa') : '';
        value['surveypublishedDate'] = (value.surveypublishedDate) ? format(new Date(value.surveypublishedDate), 'MMM dd, yyyy hh:mm aa') : '';
      })
      dispatch(setSurveyResults(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
    dispatch(setSurveyResultsLoader(false))
  }
}

// Same as above API to get all survey but automation for pagination and sorting

export const getSurveyResultsAlt = (payload) => async (dispatch, getState) => {
  const url = payload.url;
  let queryParam = payload.queryParam && payload?.queryParam
  if (payload.sortType) {
    const temp = { ...queryParam }
    temp['sort'] = payload.sortType
    queryParam = { ...temp }
  } 
  const state = getState()
  // If 'all', add survey IDs to the payload
  if(payload?.toBeSent?.surveyId[0] === 'all'){    
    let temp = []
    if(state.woundreport.surveryListOptions?.survey && state.woundreport.surveryListOptions.survey?.length > 0){
      state.woundreport.surveryListOptions.survey.map((data) => {
        temp.push(data.id)
      })
    }
    payload.toBeSent.surveyId = [...temp]
  }
  if(payload?.toBeSent?.surveyId?.length === 0){
    return;
  }
  // if (!queryParam['search'] && payload.search !== ''){
  //   const temp = { ...queryParam }
  //   temp['search'] = payload.search
  //   queryParam = { ...temp }
  // }
  const method = payload.method
  try {
    dispatch(setLoading(true));
    const data = await request(constructEndpoint(url, queryParam), {
      method: method,
      body: JSON.stringify(payload.toBeSent),
      loadingKey: LOADING_KEYS.SURVERY_RESULTS,
    });
    if (data && data.status === SUCCESS_STATUS) {
      data.data.survey.map((value)=>{
        value['submittedOn'] = (value.submittedOn) ? format(new Date(value.submittedOn), 'MMM dd, yyyy hh:mm aa') : '';
        value['surveypublishedDate'] = (value.surveypublishedDate) ? format(new Date(value.surveypublishedDate), 'MMM dd, yyyy hh:mm aa') : '';
      })
      dispatch(payload.setMethod(data.data))
    }
  }
  catch (error) {
    const obj = { ...error }
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}

/* Exclusively for CSV download */

export const getSurveyCsv = (payload, sortType,limit) => async (dispatch, getState) => {
  let endPoint = null;
  if(sortType){
    endPoint = `/reports/survey?limit=${limit}&sort=${sortType}`
  }else{
    endPoint = `/reports/survey?limit=${limit}`
  }
  try {
    dispatch(setLoading(true));
    const data = await request(endPoint, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    if (data && data.status === SUCCESS_STATUS) {
      data.data.survey.map((value)=>{
        value['submittedOn'] = (value.submittedOn) ? format(new Date(value.submittedOn), 'MMM dd, yyyy hh:mm aa') : '';
        value['surveypublishedDate'] = (value.surveypublishedDate) ? format(new Date(value.surveypublishedDate), 'MMM dd, yyyy hh:mm aa') : '';
      })
      dispatch(setSurveyResultsCsv(data.data));
      dispatch(setIsSuveyDownloadReady('downloadAllSurvey'));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
    dispatch(setSurveyResultsCsv({}));
    dispatch(setIsSuveyDownloadReady(''));
  }
  finally {
    dispatch(setLoading(false));
  }
}

// Check wheater the customer exists or not
export const checkCustomer = (payload) => async dispatch => {
  try {
    dispatch(setLoading(true));
    const data = await request(CHECK_CUSTOMER_NUMBER + '?customerNumber=' + payload, {
      method: 'GET',
    });
    if (data && data.status === SUCCESS_STATUS) {
      dispatch(setCustomerAvailable(true))
    }
  }
  catch (error) {
    const obj = { ...error }
    dispatch(setCustomerAvailable(false))
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}

//Quality Assurance overview
export const getQualityAssuranceOverViewData = (payload) => async dispatch =>{
  try {
    dispatch(setLoading(true));
    const data = await request(`${QUALITY_ASSURANCE_REPORT}/overview`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }, "REPORT");
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
      dispatch(setQualityAssuranceOverViewData(data.data));
    }
    if (data && data.status === ERROR_STATUS) {
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}

export const getQualityAssuranceCountData = (payload) => async dispatch =>{
  try {
    dispatch(setLoading(true));
    const data = await request(`${QUALITY_ASSURANCE_REPORT}/subsection-counts`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }, "REPORT");
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
      dispatch(setQualityAssuranceCountData(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}  


// Quality Assurance WoundAssessment Worklist 
export const getQualityAssuranceWoundAssessmentWorklist  = (payload) => async dispatch => {
  const url = payload.url;
  const queryParam = payload.queryParam && payload?.queryParam
  const method = payload.method
  const payloadData= payload.payload
  try {
    dispatch(setQualityAssuranceAssessmentData({}));
    const data = await request(constructEndpoint(url, queryParam), {
      method: method,
      body: JSON.stringify(payloadData),
      loadingKey: LOADING_KEYS.QUALITY_ASSURANCE_REPORT,
    }, "REPORT");
    
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
      data.data.woundAssessment.map((value)=>{
        value['lastAssessedDate'] = (value.lastAssessedDate) ? format(new Date(value.lastAssessedDate), "MM/dd/yyyy") : null;
        value['photoTakenOn'] = (value.photoTakenOn) ? format(new Date(value.photoTakenOn), 'MMMM dd, yyyy') : '';       
        value['admissionDate'] = (value.admissionDate) ? format(new Date(value.admissionDate.replace('Z', '')), 'MMMM dd, yyyy') : '';
        value['signedDate'] = (value.signedDate) ? format(new Date(value.signedDate.replace('Z', '')), 'MMMM dd, yyyy') : null;
        value['lockedDate'] = (value.lockedDate) ? format(new Date(value.lockedDate.replace('Z', '')), 'MMMM dd, yyyy') : null;
        value['dischargeDate'] = (value.dischargeDate) ? format(new Date(value.dischargeDate), 'MMMM dd, yyyy') : '';
      })
      dispatch(setQualityAssuranceAssessmentData(data.data))      
    }
  }
  catch (error) {
    const obj = { ...error }
    dispatch(setError(obj.errorMessage))
  }
}

// OverView Pages reports
export const getQualityAssuranceOverViewPages  = (payload) => async dispatch => {
  const url = payload.url;
  const queryParam = payload.queryParam && payload?.queryParam
  const method = payload.method
  const payloadData= payload.payload
  try {
    dispatch(setLoading(true));
    const data = await request(constructEndpoint(url, queryParam), {
      method: method,
      body: JSON.stringify({ ...payloadData, isDischargedPatient: false, woundType: payloadData?.woundType || [] }),
      loadingKey: LOADING_KEYS.QUALITY_ASSURANCE_OVERVIEW
    }, "REPORT");
    
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
      const finalDat = data.data;
      // finalDat.woundAssessment = payload.payload;
    if (finalDat && Array.isArray(finalDat.woundAssessment)) {
      finalDat.woundAssessment.map((value)=>{
        value['lastAssessedDate'] = (value.lastAssessedDate) ? format(new Date(value.lastAssessedDate), "MM/dd/yyyy") : null;
        value['photoTakenOn'] = value.photoTakenOn ? format(new Date(value.photoTakenOn), 'MMMM dd, yyyy') : '';     
        value['admissionDate'] = value.admissionDate ? format(new Date(value.admissionDate.replace('Z', '')), 'MMMM dd, yyyy') : '';
        value['signedDate'] = value.signedDate ? format(new Date(value.signedDate.replace('Z', '')), 'MMMM dd, yyyy') : null;
        value['lockedDate'] = value.lockedDate ? format(new Date(value.lockedDate.replace('Z', '')), 'MMMM dd, yyyy') : null;
        value['dischargeDate'] = value.dischargeDate ? format(new Date(value.dischargeDate), 'MMMM dd, yyyy') : '';
      })
      dispatch(setqaOverViewPagesData(finalDat))
      // if(payload.url==="/reports/qualityassurance/woundassessment/overview/pendingphotos" || payload.url==="/reports/qualityassurance/woundassessment/overview/pendingassessments" || payload.url==="/reports/qualityassurance/woundassessment/overview/pendingreviews" || payload.url==="/reports/qualityassurance/woundassessment/overview/completedassessments"){
      //   dispatch(postOverviewDownloadCsvReports(url, payloadData))
      // }
    }
    }else {
      if (data.message) {
        dispatch(setError(data.message));
      }
    }

  }
  catch (error) {
    const obj = { ...error }
    dispatch(setError(obj.errorMessage))
  } 
  finally {
    dispatch(setLoading(false));
  }
}

// OverView Pages reports in Csv for api call

export const postOverviewDownloadCsvReports = (urlType, payloadData) => async (dispatch) => {
  const urlPath = `${DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT_OVERVIEW}/${urlType}/csv`;

  try {
    const resp = await request(urlPath, {
      method: "POST",
      body: JSON.stringify(payloadData),
      loadingKey: LOADING_KEYS.CSV_EXPORT,
    }, "REPORT");

    if (resp?.status?.toLowerCase() === SUCCESS_STATUS) {
      const reports = Array.isArray(resp.data?.reports)
        ? resp.data.reports.map((value) => ({
            ...value,
            lastAccessed: value.lastAccessed ?? "",
            lastAssessedDate: (value.lastAssessedDate) ? format(new Date(value.lastAssessedDate), "MM/dd/yyyy") : null,
            admissionDate: value.admissionDate ? format(new Date(value.admissionDate), "MM/dd/yyyy") : "",
            dischargeDate: value.dischargeDate ? format(new Date(value.dischargeDate), "MM/dd/yyyy") : "",
            photoTakenOn: value.photoTakenOn ? format(new Date(value.photoTakenOn), "MM/dd/yyyy") : "",
          }))
        : [];

      return reports;
    } else {
      dispatch(setError(resp?.message ?? "Failed to export CSV."));
      return [];
    }
  } catch (error) {
    dispatch(setError(error?.errorMessage ?? "Unexpected error during export."));
    return [];
  }
};


// Platform analytics
export const getPlatformOverview = (payload) => async dispatch =>{
  try {
    dispatch(setLoading(true));
    const data = await request(`/reports/platformanalytics/overview`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    if (data && data.status === SUCCESS_STATUS) {
      dispatch(setPlatformOverview(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}

// Platform results
export const getPlatformResults = (payload) => async dispatch =>{
  try {
    dispatch(setLoading(true));
    const data = await request(`/reports/platformanalytics/customerdata?limit=50`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    if (data && data.status === SUCCESS_STATUS) {
      dispatch(setPlatformResults(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}

// Same as above API to get all survey but automation for pagination and sorting

export const getPlatformResultsAlt = (payload) => async (dispatch) => {
  const url = payload.url;
  let queryParam = payload.queryParam && payload?.queryParam
  if (payload.sortType) {
    const temp = { ...queryParam }
    temp['sort'] = payload.sortType
    queryParam = { ...temp }
  } 
  // if (!queryParam['search'] && payload.search !== ''){
  //   const temp = { ...queryParam }
  //   temp['search'] = payload.search
  //   queryParam = { ...temp }
  // }
  const method = payload.method
  try {
    dispatch(setLoading(true));
    const data = await request(constructEndpoint(url, queryParam), {
      method: method,
      body: JSON.stringify(payload.toBeSent)
    });
    if (data && data.status === SUCCESS_STATUS) {
      dispatch(payload.setMethod(data.data))
    }
  }
  catch (error) {
    const obj = { ...error }
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}

/* Platform results csv */

export const getPlatformResultsCsv = (payload, sortType) => async (dispatch, getState) => {
  let endPoint = null;
  if(sortType){
    endPoint = `/reports/platformanalytics/customerdata?limit=1000&sort=${sortType}`
  }else{
    endPoint = `/reports/platformanalytics/customerdata?limit=1000`
  }
  try {
    dispatch(setLoading(true));
    const data = await request(endPoint, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    if (data && data.status === SUCCESS_STATUS) {
      dispatch(setPlatformResultsCsv(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}

export const getDownloadWoundReportCSVDetails = (payload) => async dispatch => {
  try {
    dispatch(setLoading(true));
    dispatch(setWoundReportCsv([]));
    const data = await request(`${DASHBOARD_WOUNDASSESSMENT}/CSV`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }, "REPORT");
    if (data && data.status === SUCCESS_STATUS) {
      data.data.items.map((value)=>{
        const _photoDate3 = value.photoTakenon ? new Date(value.photoTakenon) : null;
        const _today3 = new Date();
        const _days3 = _photoDate3
          ? Math.floor((new Date(_today3.getFullYear(), _today3.getMonth(), _today3.getDate()) - new Date(_photoDate3.getFullYear(), _photoDate3.getMonth(), _photoDate3.getDate())) / (1000 * 60 * 60 * 24))
          : null;
        value['lastAssessedDate'] = _days3 === null ? "No photo" : _days3 === 0 ? 'Today' : _days3 === 1 ? '1 Day ago' : `${_days3} Days ago`;
        value['lastAccessed'] = (value.lastAccessed) ? format(new Date(value.lastAccessed.replace('Z', '')), 'MMMM dd, yyyy') : '';
        value['photoTakenon'] = _photoDate3 ? format(_photoDate3, 'MMMM dd, yyyy') : '';
        value['admissionDate'] = (value.admissionDate) ? format(new Date(value.admissionDate.replace('Z', '')), 'MMMM dd, yyyy') : '';
        value['signedDate'] = (value.signedDate) ? format(new Date(value.signedDate.replace('Z', '')), 'MMMM dd, yyyy') : null;
        value['lockedDate'] = (value.lockedDate) ? format(new Date(value.lockedDate.replace('Z', '')), 'MMMM dd, yyyy') : null;
        value['dischargeDate'] = (value.dischargeDate) ? format(new Date(value.dischargeDate), 'MMMM dd, yyyy') : '';
      })
      dispatch(setWoundReportCsv(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
  finally {
    dispatch(setLoading(false));
  }
}
export const getDownloadTreatmentReportCSVDetails = (payload, queryParam) => async dispatch => {
  let queryStr = ''
  if (queryParam) {
    queryStr = '?' + queryParam
  }
  try {
    const data = await request(`${DASHBOARD_TREAMENTOUTCOME_ASSESSMENT}`+queryStr, {
      method: 'POST',
      body: JSON.stringify(payload),
      loadingKey: LOADING_KEYS.TREATMENT_CSV_REPORT,
    }, "REPORT");
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
        dispatch(setTreatmentReportCsv(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
}
export const getDownloadQualityReportCSVDetails = (payload) => async dispatch => {
  try {
    const data = await request(`${DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT}/CSV`, {
      method: 'POST',
      body: JSON.stringify(payload),
      loadingKey: LOADING_KEYS.QUALITY_ASSURANCE__CSV_REPORT,
    }, "REPORT");
    if (data && data.status === SUCCESS_STATUS) {
      data.data.woundAssessment.map((value)=>{
        value['lastAssessedDate'] = (value.lastAssessedDate) ? format(new Date(value.lastAssessedDate.replace('Z', '')), 'MMMM dd, yyyy') : null;
        value['photoTakenOn'] = (value.photoTakenOn) ? format(new Date(value.photoTakenOn), 'MM/dd/yyyy') : '';
        value['admissionDate'] = (value.admissionDate) ? format(new Date(value.admissionDate.replace('Z', '')), 'MM/dd/yyyy') : '';
        value['signedDate'] = (value.signedDate) ? format(new Date(value.signedDate.replace('Z', '')), 'MM/dd/yyyy') : null;
        value['lockedDate'] = (value.lockedDate) ? format(new Date(value.lockedDate.replace('Z', '')), 'MM/dd/yyyy') : null;
        value['dischargeDate'] = (value.dischargeDate) ? format(new Date(value.dischargeDate), 'MM/dd/yyyy') : '';        
      })
      dispatch(setQualityReportCsv(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
}

export const getReportSyncStatus = () => async dispatch => {
  try {
    const data = await request(`${REPORT_DASHBOARD}/sync-status`, {
      method: 'GET',
      skipToast: true,
    }, "REPORT");
    if (data && data.status?.toLowerCase() === SUCCESS_STATUS) {
        dispatch(setReportSyncStatus(data.data));
    }
  }
  catch (error) {
    const obj = { ...error }
    /* If there are error, dispatch setError action */
    dispatch(setError(obj.errorMessage))
  }
}

export default woundReportSlice.reducer;
